<template>
  <form-group :name="getname()" class="no-margin">
    <b-form-input
      v-if="type !== 'textarea'"
      v-model="name"
      slot-scope="{ attrs, listeners }"
      :size="size"
      v-bind="attrs"
      :readonly="readOnly"
      :name="getname()"
      :type="type"
      :placeholder="placeholder"
      v-on="listeners"
      @change="onChange"
      @input="onInput"
      @update="onUpdate"
      @blur="onBlur"
      @keyup.enter="onEnter"
    />

    <b-form-textarea
      v-else
      v-model="name"
      slot-scope="{ attrs, listeners }"
      :size="size"
      v-bind="attrs"
      :readonly="readOnly"
      :name="getname()"
      :type="type"
      :placeholder="placeholder"
      v-on="listeners"
      @change="onChange"
      @input="onInput"
      @update="onUpdate"
      @blur="onBlur"
      @keyup.enter="onEnter"
    />
  </form-group>
</template>

<script>
import VuelidateMixin from "@/mixins/VuelidateMixins";
export default {
  mixins: [VuelidateMixin],
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "sm",
    },
  },
  computed: {
    name: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onEnter() {
      this.$emit("onEnter");
    },
    onChange(value) {
      this.$emit("change", value);
    },
    onInput(value) {
      this.$emit("input", value);
    },
    onUpdate(value) {
      this.$emit("update", value);
    },
    onBlur(event) {
      this.$emit("blur", event);
    },
  },
};
</script>
